module.exports = __webpack_public_path__ + "media/components/Influencers/FormTags/Categories/23-6439bd1546d58a5cad2d3270bb82c397.png";